import React from "react";
import { Modal, Button, Row, Col, Form, notification } from "antd";
import { compose } from "recompose";
import { withApollo } from "react-apollo";
import { InputComponentWithBorder } from "./AgencyFormFields";
import { createUserByAgency } from "../../../../graphQl/mutations/affiliate";
import { captureException } from "../../../../utils/sentry";
import { AGENCY_PORTAL_CLASS } from "./style";

const styles = {
  button: {
    width: "100%",
    fontFamily: "Gilroy, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    height: "40px",
  },
  title: {
    fontFamily: "Gilroy, sans-serif",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "32px",
    textAlign: "center",
    color: "#595959",
    marginBottom: 24,
  },
};

class ModalCreateAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleCancel = () => {
    const { form, onClose } = this.props;
    if (this.state.loading) {
      return;
    }
    form.resetFields();
    onClose();
  };

  handleSubmit = () => {
    const { form, agencyID, onSuccess } = this.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      this.setState({ loading: true });

      try {
        const {
          data: { createUserByAgency: response },
        } = await this.props.client.mutate({
          mutation: createUserByAgency,
          variables: {
            agencyID: parseInt(agencyID, 10),
            userInfo: {
              names: values.names.trim(),
              lastname: values.lastname.trim(),
              email: values.email.trim(),
              phone: values.phone.trim(),
            },
          },
        });

        if (!response || response.statusCode !== 200) {
          throw new Error(
            (response && response.message) || "Error al crear el afiliado."
          );
        }

        notification.success({ message: response.message });
        form.resetFields();
        this.setState({ loading: false });
        onSuccess(response.extra);
      } catch (error) {
        captureException(error);
        this.setState({ loading: false });
        notification.error({
          message:
            error.message || "Hubo un error al crear el afiliado.",
        });
      }
    });
  };

  render() {
    const { visible, form } = this.props;
    const { getFieldDecorator } = form;
    const { loading } = this.state;

    return (
      <Modal
        title={null}
        visible={visible}
        footer={null}
        onCancel={this.handleCancel}
        width="500px"
        centered
        wrapClassName={AGENCY_PORTAL_CLASS}
        bodyStyle={{ padding: 40 }}
        destroyOnClose
      >
        <p style={styles.title}>Nuevo afiliado</p>

        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={24}>
              <InputComponentWithBorder
                getFieldDecorator={getFieldDecorator}
                title="Nombres"
                decodator="names"
                placeholder="Nombres"
                required
              />
            </Col>
            <Col span={24}>
              <InputComponentWithBorder
                getFieldDecorator={getFieldDecorator}
                title="Apellidos"
                decodator="lastname"
                placeholder="Apellidos"
                required
              />
            </Col>
            <Col span={24}>
              <InputComponentWithBorder
                getFieldDecorator={getFieldDecorator}
                title="Correo"
                decodator="email"
                placeholder="Correo"
                required
              />
            </Col>
            <Col span={24}>
              <InputComponentWithBorder
                getFieldDecorator={getFieldDecorator}
                title="Teléfono"
                decodator="phone"
                placeholder="Teléfono"
                required
              />
            </Col>
          </Row>
        </Form>

        <Row gutter={24} style={{ marginTop: 24 }}>
          <Col xs={24} sm={12}>
            <Button
              type="primary"
              ghost
              style={styles.button}
              onClick={this.handleCancel}
              disabled={loading}
            >
              Cancelar
            </Button>
          </Col>
          <Col xs={24} sm={12}>
            <Button
              type="primary"
              style={styles.button}
              loading={loading}
              onClick={this.handleSubmit}
            >
              Crear afiliado
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  }
}

const ModalCreateAffiliateForm = Form.create()(ModalCreateAffiliate);

export default compose(withApollo)(ModalCreateAffiliateForm);
